import { ROOT_CATEGORY_ID } from 'components/constants-ts';
import type { IFoodlaCategoryOption } from 'models/category';
import type { IFoodlaCategory } from 'models/product';

export const getParentCategoriesData = (category: IFoodlaCategory, rootCategory: IFoodlaCategoryOption) => {
  const parent: IFoodlaCategory[] = [];
  const findParent = (currentCategory: IFoodlaCategory, rootCategory: IFoodlaCategoryOption) => {
    if (rootCategory.children) {
      for (const child of rootCategory.children) {
        if (child.id === currentCategory.id) {
          parent.push(child);
          return true;
        }
        if (findParent(currentCategory, child)) {
          parent.push(child);
          return true;
        }
      }
    }
    return false;
  };
  findParent(category, rootCategory);
  return parent.reverse().filter(item => !!item);
};

export const getCategoryPathLabel = (category?: IFoodlaCategory, rootCategory?: IFoodlaCategoryOption) => {
  if (!category?.id) return '';
  // Match the form: omit the Food/Non food root and retain the selected product's leaf name.
  const parents = rootCategory
    ? getParentCategoriesData(category, rootCategory).slice(rootCategory.id === ROOT_CATEGORY_ID ? 1 : 0, -1)
    : [];
  return [...parents.map(parent => parent.name), category.name].join(' -> ');
};

export const categoryTypeToStateField = {
  ica: 'icaCategoryId',
  ica_online: 'icaOnlineCategoryId',
  coop: 'coopCategoryId',
  wolt_online: 'woltOnlineCategoryId',
  wolt: 'woltInternalCategoryId',
  apotea: 'apoteaCategoryId',
} as const;
